import { Box, Chip, Typography, useTheme } from '@mui/material';
import React from 'react';
import { IZoneLog } from '../../models';
import dayjs from 'dayjs';
import dayOfYear from 'dayjs/plugin/dayOfYear';
import { CheckCircle } from '@mui/icons-material';

dayjs.extend(dayOfYear);

interface CleaningHistoryBlockProps {
  log: IZoneLog;
  title?: string;
  showDate?: boolean;
}

export const CleaningHistoryBlock = (props: CleaningHistoryBlockProps) => {
  const { log, title, showDate = false } = props;
  const theme = useTheme();

  const getLastServiceDay = (lastServicedDate: string): string => {
    const today = dayjs();
    const serviceDate = dayjs(lastServicedDate);
    const dayDiff = today.dayOfYear() - serviceDate.dayOfYear();

    let serviceDay = '';
    if (dayDiff === 0) {
      serviceDay = 'Today';
    } else if (dayDiff === 1) {
      serviceDay = 'Yesterday';
    } else {
      serviceDay = serviceDate.format('dddd');
    }

    return serviceDay;
  };

  const getLastServiceTime = (lastServiceDate: string): string => {
    const serviceDate = dayjs(lastServiceDate);
    return serviceDate.format('h : mm');
  };

  const getAmPm = (lastServiceDate: string): string => {
    return dayjs(lastServiceDate).format('A');
  };

  const servicesPerformed = (): string[] => {
    const services = [];
    if (log?.cleaned) {
      services.push('cleaned');
    }

    if (log?.disinfected) {
      services.push('disinfected');
    }

    if (log?.refilled) {
      services.push('refilled');
    }

    if (log?.sanitized) {
      services.push('sanitized');
    }

    if (log?.serviced) {
      services.push('serviced');
    }

    log?.service_items?.forEach((serviceItemLog) => {
      if (serviceItemLog.serviced && serviceItemLog.clean_code_zone_service_item) {
        services.push(serviceItemLog.clean_code_zone_service_item.name);
      }
    });

    return services;
  };

  return (
    <Box style={{ display: 'flex', minHeight: 125, width: '100%' }}>
      <Box
        style={{
          backgroundColor: theme.palette.primary.main,
          color: 'white',
          borderRadius: 4,
          padding: 8,
          minWidth: 100,
          display: 'inline-block',
        }}
      >
        {title && (
          <Typography variant={'caption'} style={{ display: 'block', textAlign: 'center' }}>
            {title}
          </Typography>
        )}
        {showDate && (
          <Typography variant={'h6'} style={{ fontWeight: 600, lineHeight: '1.5rem' }}>
            {getLastServiceDay(log.created_at)}
          </Typography>
        )}
        <Typography variant={'h6'} style={{ fontWeight: 600, lineHeight: '1.5rem' }}>
          {getLastServiceTime(log.created_at)}
          <span style={{ fontSize: 10 }}>{getAmPm(log.created_at)}</span>
        </Typography>
      </Box>
      <Box
        style={{
          backgroundColor: '#F6F6F655',
          color: 'rgba(0,0,0,.5)',
          marginLeft: 8,
          flexGrow: 1,
          border: '1px solid #CCCCCC55',
          borderRadius: 4,
          padding: 8,
          display: 'inline-block',
        }}
      >
        <Typography variant={'subtitle2'}>Services Performed</Typography>
        <Box mt={1}>
          {servicesPerformed().map((service, index) => (
            <Chip
              key={index}
              label={service}
              variant="outlined"
              size={'small'}
              style={{
                backgroundColor: 'white',
                borderColor: '#CCCCCC55',
                fontSize: 10,
                marginRight: 5,
                marginBottom: 5,
              }}
              icon={<CheckCircle color="primary" fontSize="small" />}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
};
